export const STYLE_OPTIONS = [
  "Casual", "Professional", "Streetwear", "Athletic", "Minimalist", "Formal",
];

export const COMFORT_OPTIONS = ["Balanced", "Relaxed", "Fitted", "Stretchy", "Layered"];

export const DRESS_FOR_OPTIONS = [
  "Class / Campus", "Work", "Gym", "Date Night", "Errands", "Party / Event", "Travel",
];

export const BODY_TYPE_OPTIONS = [
  { id: "pear", label: "Pear", note: "Balance with structure on top." },
  { id: "apple", label: "Apple", note: "Comfort + clean lines through the middle." },
  { id: "hourglass", label: "Hourglass", note: "Highlight waist, keep proportions balanced." },
  { id: "rectangle", label: "Rectangle", note: "Add shape with layers and contrast." },
  { id: "inverted", label: "Inverted Triangle", note: "Balance shoulders with volume below." },
];

export const GENDER_OPTIONS = [
  { value: "", label: "Prefer not to say" },
  { value: "woman", label: "Woman" },
  { value: "man", label: "Man" },
  { value: "nonbinary", label: "Nonbinary" },
  { value: "other", label: "Other" },
];
